

















































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  dispatchType = "users/memberpics";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "上传时间", dataIndex: "created_time" },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "上传用户", scopedSlots: { customRender: "user_id" } },
    { title: "图片", dataIndex: "picurl" },
    { title: "处理状态", dataIndex: "status" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
